import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import cl from './Active.module.css';
import { AppContext } from '../../../../providers/appProvider';

const ContainerPriceActiveModal = ({ ContainerPriceService, defaultContainerPrice }) => {
    const ContainerPriceResetData = {
        id: 0,
        name: '',
        is_active: true,
    };

    const initEditPrice = (ContainerPrice) => ({
        id: ContainerPrice.id,
        is_active: ContainerPrice.is_active ?? true,
    });

    const { app } = useContext(AppContext);
    const [newPrice, setNewPrice] = useState(ContainerPriceResetData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        const editedCar = initEditPrice(defaultContainerPrice);
        setNewPrice(editedCar);
    }, [defaultContainerPrice]);

    const openModal = () => {
        setNewPrice(initEditPrice(defaultContainerPrice));
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setNewPrice(initEditPrice(defaultContainerPrice));
        setIsModalOpen(false);
    };

    const handleToggle = (event) => {
        const updatedIsActive = event.target.checked;
        setNewPrice((prevState) => ({
            ...prevState,
            is_active: updatedIsActive,
        }));
    };

    const saveHandle = async () => {
        setIsSaving(true);
        try {
            await ContainerPriceService.updateActive({
                transport_price_id: newPrice.id,
                is_active: newPrice.is_active,
            });
            setIsModalOpen(false);
        } catch (error) {
            app?.setError?.('შეცდომა სტატუსის განახლებისას');
        } finally {
            setIsSaving(false);
        }
    };

    const checkboxId = `is_active_${newPrice.id}`;

    return (
        <div className={cl.wrapper}>
            <button type="button" className={cl.statusBtn} onClick={openModal}>
                აქტიურობა
            </button>

            <Modal size="small" isOpen={isModalOpen} onClose={closeModal}>
                <div className={cl.modalHead}>
                    <h3>სტატუსის განახლება</h3>
                </div>

                <div className={cl.modalBody}>
                    <div className={cl.formCheck}>
                        <input
                            type="checkbox"
                            checked={newPrice.is_active === true}
                            id={checkboxId}
                            onChange={handleToggle}
                        />
                        <label htmlFor={checkboxId}>აქტიური</label>
                    </div>
                </div>

                <button
                    type="button"
                    className={cl.btnPrimary}
                    onClick={saveHandle}
                    disabled={isSaving}
                >
                    {isSaving ? 'გადამუშავება...' : 'შენახვა'}
                </button>
            </Modal>
        </div>
    );
};

export default ContainerPriceActiveModal;
